var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z",
    fill: "#EAAA08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2508 9.5H11.7508V13.25H10.2508V9.5ZM10.25 14H11.75V15.5H10.25V14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3257 5.15002C12.0647 4.65877 11.5562 4.35352 10.9997 4.35352C10.4432 4.35352 9.93472 4.65877 9.67372 5.15077L4.17022 15.548C4.04809 15.7763 3.9876 16.0326 3.9947 16.2914C4.0018 16.5502 4.07626 16.8027 4.21072 17.024C4.34324 17.2463 4.53145 17.4302 4.75675 17.5575C4.98206 17.6848 5.23668 17.7512 5.49547 17.75H16.504C17.035 17.75 17.5157 17.4785 17.7895 17.024C17.9237 16.8027 17.998 16.5502 18.0051 16.2914C18.0122 16.0326 17.9519 15.7764 17.83 15.548L12.3257 5.15002ZM5.49547 16.25L10.9997 5.85277L16.5077 16.25H5.49547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2f626b22c9eae51a1a4d401039e8c8ae.svg";
export { ForwardRef as ReactComponent };